import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { ENUM__redux_action } from '../../../_base/ENUM__redux_action';
import { FN_GENERATION__update_locally } from '../../_methods/FN_GENERATION__update_locally';
import { try_remove_user_task_from_load_generations_set } from '../../_methods/try_remove_user_task_from_load_generations_set';
import { update_user_task_locally } from '../../_methods/update_user_task_locally';
import { STATE__generation } from '../../STATE__generation';

export const LOCAL__user_task_upsert = (payload: DTO__user_task[]): PayloadAction<DTO__user_task[]> => ({
  type: ENUM__redux_action.USER_TASK_UPSERT,
  payload,
});

export const INIT_LOCAL__user_task_upsert = (state: STATE__generation, action: PayloadAction<DTO__user_task[]>) => {
  if (action.payload.is_empty()) return;

  for (let item_new of action.payload) {
    update_user_task_locally(state, item_new);
    try_remove_user_task_from_load_generations_set(state, item_new);

    state.user_tasks_map.set(item_new._id, item_new);

    for (let generation of item_new.generations) {
      FN_GENERATION__update_locally(state, generation);
    }
  }

  //need refresh user_tasks_map to rerender components
  state.user_tasks_map = new Map(state.user_tasks_map);
};
